import moment from 'moment';

export const DateRangeOptions = [
  {
    label: 'Last Month',
    value: [
      moment()
        .subtract(1, 'months')
        .startOf('month')
        .toDate(),
      moment()
        .subtract(1, 'months')
        .endOf('month')
        .toDate()
    ]
  },
  {
    label: 'This Month',
    value: [
      moment()
        .startOf('month')
        .toDate(),
      moment()
        .endOf('month')
        .toDate()
    ]
  },
  {
    label: 'Calendar Year',
    value: [
      moment()
        .startOf('year')
        .toDate(),
      moment()
        .endOf('year')
        .toDate()
    ]
  }
];

export const GroupByOptions = [
  {
    value: 'donorId',
    label: 'Donor'
  },
  {
    value: 'itemId',
    label: 'Item'
  },
  {
    value: 'inventoryLocationId',
    label: 'Inventory Location'
  }
];
